const compareIr1Jcamp = `
##TITLE=Comparison 1
##JCAMP-DX=5.0
##DATA TYPE=LINK
##BLOCKS=1


$$ === CHEMSPECTRA SPECTRUM ORIG ===
##TITLE=Comparison 1
##JCAMP-DX=5.00
##DATA TYPE=INFRARED SPECTRUM
##DATA CLASS=XYDATA
##$CSCATEGORY=SPECTRUM
##ORIGIN=Exported PE Spectrum Data File
##OWNER=Admin
##XUNITS=1/CM
##YUNITS=TRANSMITTANCE
##XFACTOR=1.0
##YFACTOR=1e-07
##FIRSTX=4000.0
##LASTX=650.0
##MAXX=4000.0
##MAXY=98.5923767
##MINX=650.0
##MINY=58.8090744
##NPOINTS=3351
##XYDATA= (X++(Y..Y))
3351I72603149I72635956I72668915I72701416I72799988I72924347I72983855I72927628
3343I72796401I72676925I72620163I72614288I72624817I72634430I72632980I72595595
3335I72499771I72358475I72218933I72125778I72097778I72137375I72233658I72337112
3327I72370453I72301330I72195969I72166367I72267685I72464447I72663193I72774200
3319I72756119I72634201I72479019I72360764I72313156I72325286I72360535I72381973
3311I72386322I72429962I72561111I72745056I72884521I72934494I72956085I73036880
3303I73191681I73322296I73298187I73098601I72837830I72624054I72496566I72488327
3295I72629166I72893982I73178177I73325806I73300094I73277740I73403397I73606415
3287I73714676I73675156I73578720I73497925I73473129I73564072I73793488I74085464
3279I74278030I74264832I74116974I74018478I74018860I73990936I73939590I74053649
3271I74315414I74414902I74161072I73724976I73339539I73028946I72781371I72707672
3263I72841187I73124084I73522034I74086304I74804916I75485001I75832367I75718842
3255I75365829I74967728I74409790I73724288I73302536I73371658I73671417I73876343
3247I73993072I74111099I74018784I73546524I73120270I73377457I73879242I73723526
3239I73011780I72502747I72687836I73480225I74083710I73983765I73603592I73489380
3231I73864899I74378204I74427338I74196472I74274445I74794388I75420456I75542908
3223I74919128I74214325I74306259I74966660I74905319I73958817I73274231I73256836
3215I73336563I73174744I72886887I72781677I72974167I73440018I74124069I74898681
3207I75394745I74900742I73508148I73383331I74408875I74187851I73129501I72608795
3199I72685318I72952576I73278275I73727722I74287567I74830093I75058746I74793930
3191I74190369I73684235I73691635I74128418I74421309I74241333I73785782I73441772
3183I73436737I73645172I73704910I73462448I73175354I73293381I73896103I74469223
3175I74551163I74241562I73892975I74236679I75098800I74911423I73683090I72742996
3167I72747269I73209915I73049240I72342606I72137222I72604980I72996140I72799530
3159I72417679I72775192I73866272I74541397I74398270I74033432I73939362I74521561
3151I75027466I74469833I73615265I73351364I73500977I73435822I72933350I72454681
3143I72456360I72853165I73326035I73674469I73799973I73664932I73437729I73471222
3135I73855208I74237366I74311905I74148254I73977280I73958282I73890076I73487244
3127I72987289I72859344I73108214I73350830I73383636I73407058I73690796I74090042
3119I74130096I73802795I73616257I73812561I74041671I73948135I73784943I73947983
3111I74301224I74620285I74976196I75392456I75701981I75869750I76090088I76260071
3103I75765686I74793854I74608917I75157547I75196685I74317780I73092880I72438354
3095I73205719I74190673I73787155I73120728I73499603I74580688I75567550I76052933
3087I75985183I75515900I74803085I74057541I73638458I73458786I73089066I72527466
3079I72180023I72209320I72401276I72487564I72482986I72583771I72776184I72872543
3071I72770844I72628860I72681580I72920914I73124466I73223419I73324890I73305130
3063I72999115I72753754I72735748I72606888I72325516I72156982I72205734I72358398
3055I72462310I72410507I72283554I72269745I72270432I72132568I72078018I72334899
3047I72737274I73014679I73260193I73777924I74452744I74666367I74155121I73669205
3039I73681183I73534469I72879409I72285919I72246474I72598877I72984695I73408736
3031I74113998I74872437I75066452I74363480I73545227I74061356I74916000I74473877
3023I73636703I73355179I73520355I73935394I73862076I73126297I72465363I72240601
3015I72275772I72395248I72630386I73002625I73339691I73385773I73139648I72990416
3007I73398285I74044800I74227600I74100342I74224929I74443587I74417038I74724655
2999I75500259I75821915I75304642I74395447I73652802I73328629I73297348I73300781
2991I73242416I73250427I73409958I73530121I73460083I73421097I73735809I74312820
2983I74754333I74808502I74216156I73414917I73368149I73284149I72591324I72200927
2975I72518463I73137970I73640366I73905411I74022064I74264908I74682617I74853363
2967I74631119I74298553I74091034I74033585I73924407I73555679I73026657I72616730
2959I72534103I72731705I72931595I73043976I73222656I73524780I73870316I74175262
2951I74355316I74290009I73974762I73517074I73058395I72757263I72710342I72809830
2943I72889099I72958145I73094940I73169556I73028336I72884826I72766647I72441177
2935I72070770I71943741I72047501I72206192I72318878I72371216I72369842I72314453
2927I72210312I72101288I72044144I72079468I72218170I72464676I72804184I73123397
2919I73226700I73198471I73245544I73165359I72836685I72476119I72208328I71987152
2911I71786041I71642074I71584091I71619339I71725388I71846008I71931763I72013931
2903I72169418I72368622I72497177I72530975I72512665I72459183I72402802I72369919
2895I72299500I72133331I71918259I71758957I71701964I71704941I71712341I71729431
2887I71806870I71939544I72074814I72199936I72352295I72531052I72680359I72765350
2879I72811203I72839050I72814102I72704010I72538147I72384415I72264099I72136841
2871I71990891I71883316I71876144I71968536I72111893I72256470I72364349I72405089
2863I72387543I72371674I72427750I72566071I72711716I72779922I72764510I72711258
2855I72670288I72694626I72783890I72853317I72825012I72701263I72538834I72402191
2847I72326660I72304916I72313690I72350388I72431717I72556305I72686844I72772751
2839I72774353I72664337I72439270I72154465I71923676I71849747I71958771I72192535
2831I72450409I72639464I72699051I72613754I72425919I72225723I72093658I72055359
2823I72094650I72175751I72240829I72233658I72150726I72044754I71956406I71871338
2815I71759796I71628799I71518860I71459807I71445311I71446381I71432190I71389618
2807I71337585I71308365I71324539I71392059I71498337I71608809I71699753I71800766
2799I71960220I72147217I72227248I72108459I71885300I71744919I71753845I71809464
2791I71782913I71649094I71472092I71328812I71265259I71273040I71295853I71284866
2783I71256332I71266632I71330643I71393051I71387329I71306305I71196518I71101456
2775I71031342I70980988I70953674I70956497I70983658I71014786I71031494I71028365
2767I71011047I70993652I70986176I70967560I70890121I70743027I70604935I70595169
2759I70756531I71013412I71258316I71452942I71625824I71794205I71919861I71940460
2751I71832123I71636887I71438599I71310959I71280518I71330338I71424637I71522980
2743I71579437I71550751I71427689I71259613I71126328I71073608I71085281I71120758
2735I71169968I71248397I71347733I71421432I71431503I71390686I71344376I71330032
2727I71366730I71460037I71584396I71675873I71675186I71583481I71459732I71368713
2719I71345978I71396103I71494370I71587677I71620941I71576462I71482239I71380005
2711I71294098I71232147I71199265I71199951I71227264I71257324I71258850I71209641
2703I71105270I70954742I70767517I70554504I70341110I70169830I70077515I70065002
2695I70089187I70084610I70003357I69852447I69700927I69633179I69671249I69745941
2687I69760132I69682312I69561844I69459534I69386292I69319000I69259872I69256058
2679I69353333I69538803I69741592I69886780I69950867I69971008I70002594I70066071
2671I70131302I70152129I70112839I70035934I69948502I69858704I69776611I69741057
2663I69793472I69919434I70041275I70086365I70046996I69957199I69833298I69670029
2655I69485321I69333115I69257507I69258652I69318008I69434280I69610824I69814224
2647I69969788I70009460I69921722I69763641I69632187I69605408I69686737I69801178
2639I69858398I69829407I69758682I69701462I69664536I69628906I69612732I69681320
2631I69882355I70186385I70501709I70744247I70887832I70954895I70978775I70980148
2623I70967635I70947037I70924683I70905762I70890198I70876541I70872192I70885773
2615I70904236I70891800I70827713I70744705I70710144I70753326I70821838I70831909
2607I70761032I70677032I70680542I70820998I71060562I71299896I71439209I71438370
2599I71336517I71214141I71132965I71108322I71123123I71150436I71161499I71134185
2591I71069336I70996704I70958405I70986861I71091309I71252213I71433105I71604996
2583I71751480I71841583I71820526I71667938I71464233I71352921I71409607I71572495
2575I71721420I71809769I71890259I72015991I72147445I72178726I72047424I71808395
2567I71593094I71492844I71488876I71500473I71484756I71459427I71437378I71386337
2559I71273575I71124878I71008911I70964127I70963135I70952301I70908432I70846863
2551I70781860I70700912I70591354I70481567I70429764I70464554I70559311I70674744
2543I70803299I70949553I71081009I71134796I71077194I70937729I70781021I70667343
2535I70634308I70679703I70749207I70769882I70716705I70640869I70618514I70670547
2527I70742950I70760727I70691452I70559921I70413971I70284119I70176392I70094528
2519I70048981I70039748I70046616I70047379I70033417I70000839I69952240I69920807
2511I69956512I70058289I70144806I70131531I70026398I69916076I69866028I69865189
2503I69862976I69823456I69737854I69615097I69473495I69330444I69196701I69085540
2495I69013138I68973541I68930435I68857498I68772202I68695908I68587723I68364029
2487I67995071I67540894I67074203I66594086I66034088I65326080I64434280I63353043
2479I62103043I60724869I59264679I57766495I56267929I54783936I53300629I51805725
2471I50330353I48945236I47710571I46646804I45761871I45086670I44666595I44524155
2463I44635544I44939728I45375519I45918503I46580200I47361145I48219223I49099274
2455I49976806I50855179I51722336I52528457I53215256I53767624I54230881I54675751
2447I55147171I55643921I56141129I56621399I57081070I57524033I57972488I58471222
2439I59048080I59667282I60252686I60767899I61241684I61707534I62157288I62578812
2431I62996368I63424377I63797379I64007797I64026947I63951340I63923950I64032440
2423I64277115I64597702I64908905I65131836I65231018I65235824I65217361I65231934
2415I65279541I65319138I65320206I65294876I65276184I65272903I65255966I65194550
2407I65100478I65023651I65007248I65053787I65126419I65177002I65175095I65118027
2399I65022049I64911880I64819182I64772873I64772110I64774322I64728165I64625626
2391I64509277I64419785I64355698I64294585I64240646I64233017I64306107I64443893
2383I64570541I64587326I64445419I64200668I63986130I63906097I63952179I64028397
2375I64050446I64005661I63931885I63869095I63834381I63820343I63801270I63745728
2367I63633804I63466263I63258667I63028336I62789993I62567673I62402802I62334366
2359I62361450I62435455I62505492I62561874I62620087I62674026I62699814I62702103
2351I62718506I62771071I62842331I62908936I62968521I63017426I63034210
2344I63013306I62992401I63017044I63090286I63177872I63248215I63282547
2337I63255310I63136215I62913895I62606506I62254333I61910858I61619949
2330I61376801I61121063I60790253I60368576I59866562I59272307I58553314
2323I57699127I56731415I55677109I54556961I53401489I52250061I51128235
2316I50043488I49005966I48032913I47129593I46287079I45505981I44811478
2309I44244155I43843155I43632278I43604965I43722763I43948059I44280319
2302I44747161I45354538I46061478I46806563I47553177I48306122I49087372
2295I49894714I50684509I51406555I52058333I52683333I53305130I53885421
2288I54372864I54774017I55152664I55572128I56060715I56607742I57156067
2281I57613068I57912903I58074951I58178711I58293686I58455353I58683472
2274I58969574I59254150I59473267I59636917I59819260I60058670I60305176
2267I60486984I60602951I60721664I60899734I61117401I61292496I61350861
2260I61286545I61166687I61083374I61095199I61201630I61355362I61489334
2253I61550597I61522827I61431808I61316299I61208496I61139450I61126938
2246I61150589I61150513I61076508I60933914I60771790I60637436I60551147
2239I60508575I60487213I60461960I60435638I60445404I60522690I60654221
2232I60801238I60948334I61114197I61317902I61555023I61805496I62049789
2225I62279358I62500381I62718506I62913055I63042603I63095398I63121109
2218I63187408I63311996I63458175I63584899I63673096I63715057I63719788
2211I63729248I63795700I63929825I64092178I64234009I64329147I64375000
2204I64393997I64435425I64544296I64711609I64869003I64944305I64919891
2197I64839325I64771957I64769897I64843140I64964218I65095825I65213852
2190I65304947I65357361I65368422I65356522I65350342I65366592I65403519
2183I65450821I65497513I65541076I65601883I65718079I65909348I66145096
2176I66363373I66521606I66624146I66703033I66782150I66856155I66900253
2169I66901855I66884995I66892624I66941833I67006989I67050705I67060776
2162I67057190I67081604I67182541I67379074I67620239I67804260I67865143
2155I67832642I67790070I67789612I67827988I67883759I67943954I67995758
2148I68020401I68003693I67943726I67851334I67756041I67701645I67719040
2141I67799377I67898941I67967453I67976303I67938614I67907181I67929686
2134I67992249I68031235I68016052I67995377I68035202I68131332I68214187
2127I68231125I68196030I68162383I68169631I68213120I68251648I68248520
2120I68218230I68218384I68280792I68366928I68409805I68384093I68315353
2113I68239365I68181763I68159943I68169708I68173752I68135910I68065262
2106I68000031I67949982I67884826I67787247I67687225I67629089I67618332
2099I67616806I67591171I67557602I67568970I67648392I67747040I67791519
2092I67771454I67748184I67765579I67792664I67778549I67731171I67700043
2085I67698975I67687531I67623520I67500458I67339401I67176361I67057495
2078I67016373I67047424I67112885I67174454I67208557I67206192I67179565
2071I67157822I67157669I67167740I67182465I67228699I67328262I67448044
2064I67524033I67531891I67505569I67488861I67499466I67536392I67590408
2057I67641068I67668915I67679825I67700348I67747115I67813797I67885132
2050I67949599I68004990I68065719I68152390I68257599I68333817I68342361
2043I68301238I68261108I68243560I68231735I68211136I68182526I68136520
2036I68053894I67943954I67857818I67848129I67924118I68046875I68158417
2029I68217163I68219147I68186722I68134766I68063736I67992783I67971268
2022I68030396I68136062I68217163I68230057I68177185I68084412I67994232
2015I67964859I68029098I68152618I68265228I68336868I68394318I68467635
2008I68556976I68653870I68756485I68851547I68910980I68924255I68912582
2001I68901520I68899689I68910446I68940048I68980865I69006195I68997879
1994I68971785I68965224I69003983I69077911I69140549I69136734I69046860
1987I68907166I68781357I68716431I68723297I68777924I68827820I68821793
1980I68760223I68703613I68706055I68755035I68798218I68809891I68798599
1973I68767470I68705902I68616257I68517380I68424683I68348999I68303833
1966I68287659I68276062I68259583I68269653I68329697I68396835I68400421
1959I68333282I68264771I68268280I68370437I68558350I68787003I68979645
1952I69072952I69077835I69063644I69074553I69093552I69089737I69065018
1945I69042282I69036713I69050369I69074326I69088974I69077072I69041443
1938I68999634I68969116I68964005I68985291I69000702I68960876I68861008
1931I68753433I68666840I68546600I68326340I68038406I67802582I67712708
1924I67773666I67935104I68136368I68328400I68498459I68677673I68887177
1917I69081650I69186325I69187164I69145355I69126434I69153900I69228210
1910I69349670I69511337I69698715I69900055I70101089I70278625I70422974
1903I70549850I70665435I70737534I70734024I70677261I70625153I70611649
1896I70631027I70661850I70675735I70648956I70604706I70626373I70786438
1889I71068344I71378937I71617050I71708832I71622696I71405029I71180267
1882I71061172I71055984I71088181I71086884I71033859I70954666I70902634
1875I70924530I71007919I71086502I71125565I71160507I71220856I71272430
1868I71281586I71278763I71291809I71269379I71152649I70985336I70868225
1861I70823516I70785370I70709686I70616149I70528641I70449829I70394058
1854I70378035I70373993I70331116I70249100I70178375I70144119I70119476
1847I70077896I70032043I70013962I70044174I70112456I70172195I70177155
1840I70146484I70156937I70243530I70352478I70428772I70496750I70601425
1833I70724411I70815201I70854034I70823746I70680695I70437088I70220718
1826I70159912I70242538I70370026I70504150I70658875I70790405I70818633
1819I70753479I70690155I70671158I70647278I70582504I70506897I70454329
1812I70425262I70424194I70463562I70521622I70560226I70579758I70595093
1805I70577698I70503159I70437927I70478592I70601730I70672150I70619583
1798I70518265I70471420I70498428I70560379I70617981I70639420I70617599
1791I70602264I70651855I70738983I70770187I70716552I70654602I70655365
1784I70697784I70720139I70698166I70647507I70595779I70577164I70612410
1777I70679550I70737534I70780869I70831223I70884323I70919189I70953369
1770I71026917I71126785I71186447I71172637I71125107I71102524I71132889
1763I71213379I71310577I71361694I71324387I71228180I71135864I71065216
1756I70991592I70905609I70813216I70701599I70568771I70469360I70459366
1749I70504150I70514221I70470734I70447083I70498198I70593109I70665054
1742I70677032I70631332I70564041I70532150I70563278I70623093I70674057
1735I70745316I70886230I71071547I71235046I71393814I71635284I71954422
1728I72222214I72372360I72487410I72599335I72545700I72179947I71627121
1721I71165848I70916671I70772247I70544739I70093536I69491043I69146652
1714I69506073I70508498I71591797I72294006I72490234I72307358I71926880
1707I71604766I71520996I71513748I71363068I71105194I70977859I71073380
1700I71269684I71344681I71051178I70445480I70059891I70375443I71171570
1693I71916885I72349854I72410049I72142715I71668395I71229630I71054077
1686I71218719I71563110I71914139I72209320I72476959I72628173I72542953
1679I72284469I72012405I71831589I71716690I71663971I71701279I71756744
1672I71743622I71693802I71782608I72055359I72360153I72506561I72430038
1665I72200165I71938171I71767120I71731949I71776962I71804123I71801605
1658I71818085I71865997I71884688I71822510I71711197I71613464I71571579
1651I71571045I71584702I71614380I71704025I71880722I72076721I72190475
1644I72209549I72240219I72337036I72420349I72396469I72310486I72267761
1637I72285004I72310791I72348862I72443848I72571487I72664566I72729187
1630I72843933I73031158I73246384I73471069I73728104I73990173I74163818
1623I74179001I74031448I73770065I73504257I73382874I73472824I73676682
1616I73839569I73901520I73883972I73815765I73751602I73794022I73983383
1609I74223099I74409561I74543152I74629898I74579773I74361801I74147873
1602I74138794I74325027I74573593I74864807I75249710I75642090I75860977
1595I75867538I75787506I75724487I75702515I75746689I75852966I75924225
1588I75902557I75919571I76141205I76502075I76769257I76833801I76775894
1581I76698685I76674881I76791229I77040405I77211075I77089996I76748047
1574I76448669I76325302I76325531I76394501I76498795I76534119I76441650
1567I76375885I76532822I76851349I77094727I77182388I77222366I77272415
1560I77304686I77358475I77488632I77607117I77605286I77577744I77683411
1553I77854156I77906952I77881087I77973099I78179703I78296814I78247910
1546I78122864I77918854I77566528I77220230I77199326I77576294I78067474
1539I78372650I78413619I78254851I78051376I78055878I78390732I78816833
1532I79003372I79001694I79144287I79512024I79842911I79976654I80050583
1525I80189056I80306320I80307312I80240097I80182724I80171738I80249710
1518I80393677I80427628I80223389I79959793I79965515I80378571I81169434
1511I82326202I83675689I84695129I84963531I84665222I84249268I83810654
1504I83179855I82413101I81778641I81354523I81014633I80759430I80715332
1497I80828781I80878448I80779953I80611115I80389099I80102997I79899292
1490I79941711I80126953I80213089I80188446I80230331I80335540I80291595
1483I80010910I79631041I79283371I78978882I78714981I78507309I78328400
1476I78168564I78113251I78204117I78296051I78229752I78069611I77976607
1469I77935486I77829514I77704773I77703552I77780838I77756653I77633209
1462I77593765I77682342I77742310I77698746I77657242I77683945I77718276
1455I77741623I77817535I77919312I77923355I77824478I77783736I77926483
1448I78231812I78611298I78933487I79009780I78755569I78346710I78045731
1441I77914276I77858809I77877274I78035355I78256149I78378754I78398590
1434I78417511I78395233I78214874I77980576I77970276I78263931I78655701
1427I78959961I79169235I79292526I79295807I79244919I79285126I79432449
1420I79561768I79599762I79553223I79394684I79134369I78947601I78986511
1413I79147186I79255905I79380341I79696503I80139618I80481949I80675964
1406I80806655I80786667I80469208I80029678I79866714I80099716I80466690
1399I80748596I80963669I81108780I81107635I81072921I81249084I81639252
1392I82011337I82284393I82549820I82733078I82642212I82355499I82179336
1385I82212677I82318420I82481461I82796707I83160858I83380890I83518448
1378I83732986I83894958I83794174I83606262I83685455I83995667I84214096
1371I84282074I84368514I84400330I84176865I83893280I83931198I84211197
1364I84301300I84073639I83805542I83690262I83700104I83872910I84238205
1357I84505386I84326630I83829269I83442992I83286209I83141403I82924500
1350I82740784I82568817I82296753I82011490I81871414I81779633I81536484
1343I81268921I81260452I81426163I81514664I81623154I81982573I82417526
1336I82541885I82365341I82203292I82102737I81905441I81804123I82213135
1329I83081818I83932342I84603653I85289154I85867004I85923767I85454483
1322I84878922I84363708I83752136I83183060I83127518I83615189I84108353
1315I84292067I84339828I84396133I84340591I84124451I83871841I83572998
1308I83104553I82586746I82315673I82315750I82337646I82286758I82269439
1301I82242584I82056351I81821136I81802139I81956482I81987839I81871872
1294I81916885I82224883I82513123I82591629I82556763I82470779I82235870
1287I81858597I81513138I81292725I81185150I81278076I81662978I82137527
1280I82382811I82403717I82436142I82462234I82182465I81546707I80941696
1273I80688095I80681381I80785294I81089172I81596603I82065811I82273102
1266I82209166I81986237I81684113I81391373I81196823I81055603I80893631
1259I80811310I80920792I81101151I81150589I81124420I81208115I81362305
1252I81414107I81395034I81456833I81544036I81461029I81260300I81201096
1245I81290817I81259003I81022110I80808640I80828781I81085052I81448669
1238I81710281I81683426I81396561I81163024I81254272I81529236I81660613
1231I81600647I81545258I81547470I81462631I81256027I81048965I80851517
1224I80581970I80335846I80299530I80348740I80166016I79914702I79924164
1217I80026092I79984283I79886932I79899216I79958649I79904709I79792557
1210I79796906I79882050I79868317I79757538I79694443I79685059I79655533
1203I79673919I79831467I80043335I80119324I80093765I80251617I80733260
1196I81313934I81820526I82218704I82094040I81313095I80452271I80009460
1189I79902802I79827499I79789581I79928054I80099258I80055847I79821930
1182I79597168I79522781I79646301I79848938I79982758I80024643I79933548
1175I79829178I79835129I79809723I79668579I79578171I79723663I79976959
1168I80047989I79965897I79953384I79974594I79818649I79527206I79429321
1161I79572601I79637527I79533234I79477386I79531325I79535522I79469910
1154I79481735I79561615I79584122I79657822I79947128I80211945I80152816
1147I79972763I80186920I80897064I81578903I81947937I82292175I82400208
1140I81928101I81192780I80679321I80420151I80165176I79887694I79652405
1133I79306641I78699036I78030853I77661438I77420120I76924896I76306000
1126I76141433I76644363I77112579I77019501I76785126I76398086I75734711
1119I75263748I75306625I75460205I75269623I75014954I75261917I76043091
1112I76804123I77045593I76876449I76669540I76536560I76488113I76527939
1105I76565094I76628418I76719437I76783447I76607513I75770645I74594345
1098I73888550I73668441I73288651I72568817I72058487I71956558I71603088
1091I70502243I69129791I67869720I66580582I65315018I63424454I60204468
1084I56714401I52909164I48651428I45073317I42786560I41731949I41587982
1077I41787949I41564789I40645142I39614410I38799286I37801056I36205444
1070I33357925I27612456I18208923I06640854H93999405H80730057H67230301
1063H53576279H39742508H26127472H13391953H01199417G87495041G70669022
1056G53615417G40885620G32315369G23900452G09723434F90439148F75545807
1049F66577758F59900055F54004593F49892044F48400497F49126816F52354126
1042F58896790F69935913F85783463G03954390G22202758G42951279G72955627
1035H08147583H30825806H40582733H46402817H51809235H56092758H58217697
1028H57509842H51941528H40891800H28264084H16574783H04061432G87477722
1021G65703506G43607559G26447525G14077148G04385147F95213852F83972473
1014F69759750F55835266F45149689F36795845F29594803F23785896F20046082
1007F18458443F18176994F14920235F06945724F02341614F00707321E99047966
1000E97835007E95605507E91129494E88090744E88827782E91284103E94645081
993E99632683F06553650F14741440F23620949F33804855F46745834F62246552
986F76852722F88231125F97009659G04800186G12815628G21404266G30255737
979G38605881G45880737G52423325G59096069G66238556G73381195G80059662
972G86270218G92356567G99011841H06802597H15509491H23672637H29642334
965H33629990H37307510H41592788H45915297H49497604H52255554H53978653
958H53935623H51847076H48047028H42635727H35847855H29024506H23842316
951H20815811H19583129H20055922H22509460H26937714H32918167H40021133
944H47913513H56056366H63747940H70645065H76923676H82679290H87640076
937H91743851H95432891H98941345I01936188I04301147I06428223I08542023
930I10477676I12085190I13191605I13702469I13373642I11788483I09783173
923I08715515I08299026I07369385I06568527I06568756I06191025I04763641
916I03049240I01534576I00603333I00370941I01137466H95972672H73837662
909H52287445H41564713H30017166H14252701G97290649G83035583G71565247
902G60603485G50154572G42887344G40179138G40804367G43542404G47938080
895G53739395G60928040G70137405G83032532G99562607H14642868H24380264
888H29840851H34568786H41665192H51736832H62050476H69767456H75176238
881H79710922H84002991H88048401H91914597H95635300H98906937I01837006
874I05392838I10045395I14629288I17676773I18904953I19037628I18719788
867I18610306I19145355I19728775I19787445I19281920I18692169I18348770
860I18032303I15965347I11806563I09920654I09279633I05880890I00530624
853H95015259H89670639H84147873H78089218H70344315H59510193H47343674
846H37042312H28731308H21152039H13275681H03530731G91576004G80582428
839G73137741G68283310G64604568G61892395G60170898G58961487G57831268
832G57173157G57736281G59574585G62299271G65701522G69736786G74272919
825G79208374G84734344G90656128G95868072G99710312H02776947H05798721
818H08615189H10141068H09445877H07088242H04214706H01113510G98000870
811G95144119G92094420G86581116G78899307G74471435G73636169G73633499
804G74663391G77248459G80832825G84438629G87785721G91124344G94395675
797G97282561G99789809H02106094H04265366H06120377H07689285H09205475
790H10639191H10942078H08399276H03340607G97558823G91324539G84579544
783G77960281G72309341G68625259G68015747G70958939G76694946G84293060
776G93496627H03700333H13427200H21950531H30023346H38204498H45372009
769H50065308H52535018H53978424H55245895H56525192H57489090H57638168
762H56682891H54783554H52316360H49534760H46480484H43151016H39936218
755H37710571H36993484H37459335H38613663H40213699H42267456H44906920
748H48217010H52265167H56777649H61029663H64415817H66877440H68913269
741H71197433H74133606H77629471H81181488H84327163H86984329H89301529
734H91395874H93305664H95098343H96820908H98417282H99872360I01220703
727I02318268I02849045I02865219I02765045I02409592I01155242H98527985
720H94354706H88669434H81696547H73527985H63591460H50664062H34666977
713H18704605H06494522G98788147G94714127G93933945G96556244H02381439
706H10667114H20406036H30620345H40586853H49914627H58477097H66263580
699H73220291H79306488H84639130H89435805H93775558H97560272I00734406
692I03408051I05754929I07908630I09935226I11769333I13186798I13924255
685I13826447I12837296I10912552I08116989I04820938I01626511H99075089
678H97518845H97188949H98192673I00396576I03445282I06962357I10677566
671I14358521I17770386I20794373I23452225I25752486I27663879I29263229
664I30738678I32175827I33483276I34583511I35516433I36328278I37011948
657I37582169I38063736I38379288I38389740I38048324I37369232I36237030
650I34385529I31561356I27570038I22176514I15122833I06289978H95808411
643H84100494H71881332H60018158H49325027H40509033H34186401H30773468
636H30388718H32911530H38055725H45368422H54234924H63919677H73668900
629H82892380H91260681H98615799I04897842I10200500I14737778I18658981
622I21991959I24795609I27211685I29320526I31098480I32550888I33740387
615I34662932I35246506I35491409I35467147I35158081I34456406I33310547
608I31729279I29655075I26982269I23682175I19761047I15097733I09432526
601I02465439H93844147H83129578H69942322H54175797H36117706H16609039
594G97149506G79538040G65220871G54997635G49068985G47063446G48180388
587G51528397G56295471G61661835G66807327G71120911G74386826G76821976
580G78997421G81652374G85402527G90494308G96800232H03990784H11639481
573H19241486H26263733H32217407H36709747H39505768H40591583H40223312
566H38973159H37692947H37298126H38453064H41345139H45689240H50949631
559H56581801H62156371H67397156H72141266H76236191H79505234H81821976
552H83136902H83397446H82515869H80435333H77173004H72846298H67770615
545H62501526H57665253H53715515H50837326H49006195H48105087H48046646
538H48858871H50683060H53676758H57878722H63122330H69051284H75216293
531H81171188H86564713H91245041H95264282H98737410I01725082I04257584
524I06386719I08176498I09707184I11100159I12461166I13791046I15024643
517I16149368I17198715I18153381I18968353I19691620I20429001I21185684
510I21859741I22403411I22874069I23324661I23763504I24222564I24739075
503I25263596I25704498I26062621I26410446I26748657I27011490I27200089
496I27378235I27540817I27618026I27602615I27544937I27439041I27254105
489I27057877I26953506I26899948I26755142I26503830I26295166I26246948
482I26359177I26617661I27028046I27533417I28043594I28566132I29179840
475I29874954I30549622I31157684I31722107I32225952I32648621I33073196
468I33572998I34024429I34241714I34291000I34450912I34851151I35357971
461I35822220I36215057I36497040I36599350I36597900I36689986I36931229
454I37180786I37350998I37522353I37759705I37996979I38163528I38273926
447I38345413I38364792I38362732I38371048I38291625I37968979I37406845
440I36745071I36020203I35136566I34077072I32954712I31842270I30715256
433I29569855I28447418I27330704I26147307I24900436I23689804I22601165
426I21678162I20989075I20603409I20505446I20627975I20962524I21543503
419I22348175I23325424I24505768I25955963I27619858I29321747I30942992
412I32487793I33970413I35354309I36616135I37757874I38742827I39523315
405I40132217I40634079I40980148I41076584I41017685I41032104I41169662
398I41261673I41167679I40861893I40314255I39456024I38254471I36692276
391I34662628I31980895I28487015I24041824I18456345I11536941I03184052
384H93388062H82235565H70059891H57525177H45453415H34610062H25673676
377H19274445H15946732H16017227H19483871H25947571H34692993H44879913
370H55713577H66539459H76854935H86270142H94530792I01603928I07645721
363I12816772I17183838I20811157I23840942I26436386I28718567I30782852
356I32694626I34444427I35980225I37301788I38467407I39517288I40467300
349I41359177I42224274I43005905I43608322I44006805I44219131I44189606
342I43807449I43017578I41787262I39965973I37293091I33550262I28604660
335I22319641I14547577I05228653H94424744H82292252H69121780H55402908
328H41820145H29231339H18645629H11097794H07445221H08194504H13332825
321H22190475H33534164H45933304H58174133H69496689H79573288H88329773
314H95816193I02178879I07600937I12202072I16045151I19239807I21949768
307I24278793I26230392I27802962I29063721I30122833I31089935I32045517
300I32997207I33883896I34674759I35424652I36169739I36836395I37345734
293I37752533I38169250I38598633I38956528I39221344I39430542I39542465
286I39409866I38880920I37854385I36306534I34402161I32534637I31104431
279I30259476I29943237I30139313I30924759I32293472I34056701I35939636
272I37690048I39119568I40174332I40981903I41714554I42395172I42932204
265I43317871I43649672I43955154I44151382I44217300I44267044I44393158
258I44545135I44616623I44570923I44446259I44310226I44228287I44211960
251I44192123I44096909I43939819I43770981I43583450I43351440I43113022
244I42912750I42690506I42325897I41772766I41063080I40207214I39177246
237I37954025I36501465I34739838I32644424I30327377I27928238I25486984
230I23035583I20722504I18698120I16950760I15405197I14101562I13119507
223I12397232I11770325I11119766I10352783I09323349I07918320I06174850
216I04199982I02050400H99827728H97833710H96473999H96008530H96477737
209H97823639H99969635I02804642I06204987I10073242I14266052I18504105
202I22476730I26049271I29271088I32190933I34780045I37019958I38936157
195I40545731I41886444I43076324I44219818I45273972I46125870I46781540
188I47361679I47944336I48539581I49179230I49877472I50520476I50959853
181I51234360I51540680I51958084I52373276I52706298I52997818I53223800
174I53277969I53194580I53158340I53292007I53587112I53970794I54328613
167I54547195I54629363I54691086I54772644I54767609I54629898I54513473
160I54569320I54726791I54788818I54559020I53699341I51760483I48860321
153I46083145I44710388I45243072I47191086I49548035I51483765I52713470
146I53405380I53877486I54332047I54779282I55149002I55407791I55553741
139I55593567I55581970I55602417I55656891I55664748I55612335I55591583
132I55648499I55723267I55783081I55870972I55985260I56063461I56107407
125I56142044I56044617I55647049I55015105I54342804I53536758I52212067
118I50069580I46711197I40740128I29418106I09929885H81822357H49260178
111H21410828H09140167H18281860H44427261H74976959H97421570I06141129
104I01938400H86856766H60939636H23206787G74245911G18243026F63726654
97F21435738E98869781E95642624F04707527F18635445F34514084F53255157
90F75946350G01960526G29533156G56665955G81581421H03283081H21829910
83H37670441H50852280H61207886H69029922H75161514H80593262H86171417
76H92342377H98835678I04849548I09823990I13872069I17347564I20323868
69I22788010I24952850I27002411I28839340I30361557I31725464I33081512
62I34316254I35318756I36223526I37115250I37742615I37718201I36717758
55I34325867I30190811I24873962I20269623I18537903I20456238I24949036
48I30162277I34768143I38326111I40915451I42733078I43922806I44625778
41I45082397I45553818I46088562I46537552I46895294I47339020I47869186
34I48272629I48502960I48769836I49155121I49461212I49577408I49660797
27I49805222I49862137I49747543I49752426I50281677I51749573I54370651
20I58089600I60941391I59978867I56565475I53749619I52412643I52180252
13I52351837I52619858I52870102I53056488I52881622I52989120I52655182
6I53254013I49391022I46837997I46414413I43963852I40565491
$$ === CHEMSPECTRA INTEGRALS AND MULTIPLETS ===
##$OBSERVEDINTEGRALS= (X Y Z)

##$OBSERVEDMULTIPLETS=
##$OBSERVEDMULTIPLETSPEAKS=
$$ === CHEMSPECTRA SIMULATION ===
##$CSSIMULATIONPEAKS=
##END=


$$ === CHEMSPECTRA PEAK TABLE EDIT ===
##TITLE=RackMultipart20200901-27241-1rtkvkz
##JCAMP-DX=5.00
##DATA TYPE=INFRAREDPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=EDIT_PEAK
##$CSTHRESHOLD=0.93
##MAXX=4000.0
##MAXY=98.5923767
##MINX=650.0
##MINY=58.8090744
##$CSSOLVENTNAME=- - -
##$CSSOLVENTVALUE=0
##$CSSOLVENTX=0
##NPOINTS=21
##PEAKTABLE= (XY..XY)
744.0, 59.5642624
759.0, 80.91401669999999
860.0, 89.600853
973.0, 80.7445221
1025.0, 81.5946732
1188.0, 84.8046646
1213.0, 83.7298126
1238.0, 74.7063446
1285.0, 83.0388718
1326.0, 89.71889499999999
1358.0, 79.3933945
1403.0, 83.69934839999999
1429.0, 76.8015747
1454.0, 77.3633499
1481.0, 75.7173157
1548.0, 74.0179138
1562.0, 90.03709409999999
1569.0, 90.6568527
1599.0, 81.95831299999999
1646.0, 58.8090744
1694.0, 64.8400497
##END=


$$ === CHEMSPECTRA PEAK TABLE AUTO ===
##TITLE=RackMultipart20200901-27241-1rtkvkz
##JCAMP-DX=5.00
##DATA TYPE=INFRAREDPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=AUTO_PEAK
##$CSTHRESHOLD=0.93
##MAXX=4000.0
##MAXY=98.5923767
##MINX=650.0
##MINY=58.8090744
##NPOINTS=21
##PEAKTABLE= (XY..XY)
1569.0, 90.6568527
1562.0, 90.03709409999999
1326.0, 89.71889499999999
860.0, 89.600853
1188.0, 84.8046646
1213.0, 83.7298126
1403.0, 83.69934839999999
1285.0, 83.0388718
1599.0, 81.95831299999999
1025.0, 81.5946732
759.0, 80.91401669999999
973.0, 80.7445221
1358.0, 79.3933945
1454.0, 77.3633499
1429.0, 76.8015747
1481.0, 75.7173157
1238.0, 74.7063446
1548.0, 74.0179138
1694.0, 64.8400497
744.0, 59.5642624
1646.0, 58.8090744
##END=

##END=


`;

export default compareIr1Jcamp;
